import type { TranslationModule } from '../types';

export const authTranslations: TranslationModule = {
  ro: {
    loginSeoTitle: "Autentificare - LegeaAplicata.ro",
    loginSeoDesc: "Intră în contul tău LegeaAplicata.ro sau creează un cont nou. Acces la asistentul juridic AI, căutare spețe și legislație actualizată.",
    loginSeoKeywords: "login legea aplicata, autentificare, inregistrare cont, platforma juridica",
    registerSeoTitle: "Înregistrare - LegeaAplicata.ro",
    registerSeoDesc: "Înregistrează-te gratuit și ai acces instant la inteligența artificială juridică, căutare în jurisprudență și instrumente utile.",
    registerSeoKeywords: "inregistrare legea aplicata, cont nou, creeaza cont",
    verifyEmailSeoTitle: "Confirmare Email - LegeaAplicata.ro",
    forgotPasswordSeoTitle: "Resetare Parolă - LegeaAplicata.ro",
    resetPasswordSeoTitle: "Setare Parolă Nouă - LegeaAplicata.ro",
    completeProfileSeoTitle: "Bun venit - LegeaAplicata.ro",
    welcomeTitle: "Bine ai venit",
    createAccountTitle: "Creează cont",
    loginSubtitle: "Intră în contul tău pentru a continua",
    registerSubtitle: "Înregistrează-te gratuit în câteva secunde",
    loginTab: "Autentificare",
    registerTab: "Creează cont gratuit",
    emailLabel: "Email",
    emailPlaceholder: "exemplu@email.com",
    passwordLabel: "Parolă",
    passwordPlaceholder: "••••••••",
    confirmPasswordLabel: "Confirmă parola",
    confirmPasswordPlaceholder: "Repetă parola",
    fullNameLabel: "Nume complet",
    fullNamePlaceholder: "Nume și Prenume",
    passwordMinChars: "Minim 8 caractere, cu litere și cifre",
    passwordTooShort: "Parola trebuie să conțină minimum 8 caractere.",
    passwordLettersDigits: "Folosește cel puțin o literă și o cifră.",
    passwordWeak: "Această parolă este prea ușor de ghicit. Alege alta.",
    passwordTooLong: "Parola este prea lungă: maximum 72 de octeți UTF-8. Unele caractere ocupă mai mulți octeți.",
    passwordInvalidCharacter: "Parola conține un caracter neacceptat.",
    changePassword: "Schimbă parola",
    changePasswordHint: "Pentru siguranța contului, îți vom trimite un link pentru stabilirea unei parole noi.",
    showPassword: "Afișează parola",
    hidePassword: "Ascunde parola",
    adminPasswordHint: "Stabilește o parolă nouă. Parola nu este trimisă prin e-mail.",
    passwordUpdated: "Parola a fost resetată cu succes!",
    cancelPassword: "Anulează",
    rememberMe: "Ține-mă minte",
    forgotPasswordLink: "Ai uitat parola?",
    orDivider: "Sau continuă cu",
    loginWithGoogle: "Autentifică-te cu Google",
    registerWithGoogle: "Creează cont cu Google",
    googleRateLimited: "Prea multe încercări cu Google. Te rugăm să aștepți înainte de a reîncerca.",
    googleRetryCountdown: "Reîncearcă în {seconds} secunde",
    googleRegistrationHint: "Fără o parolă nouă. Confirmi termenii în pasul următor.",
    registerWithEmailDivider: "Sau creează cont cu email",
    googleRegistrationSubtitle: "Un singur pas înainte de a continua la Google.",
    googleRegistrationNext: "Alegi contul Google, apoi revii automat în platformă. Numele și adresa de email se preiau din contul ales.",
    googleConsentBefore: "Prin apăsarea butonului „Acceptă și continuă cu Google”, accepți ",
    googleConsentBetween: " și confirmi că ai citit ",
    googleConsentPrivacy: "Politica de Confidențialitate",
    googleAcceptContinue: "Acceptă și continuă cu Google",
    googleRedirecting: "Se deschide Google…",
    backToRegistrationMethods: "Înapoi la metodele de înscriere",
    accountType: "Tipul contului",
    accountTypeIndividual: "Persoană fizică",
    accountTypeCompany: "Persoană juridică",
    accountTypeHint: "Datele de facturare se completează separat înainte de plată și pot fi diferite de tipul contului.",
    googleAccountNotFound: "Acest cont Google nu este încă înregistrat. Pentru a crea contul, consultă termenii de mai jos și continuă cu Google.",
    googleEmailConflict: "Adresa Google este deja asociată unui cont creat cu email și parolă. Autentifică-te cu parola sau folosește resetarea parolei.",
    googleInvalidState: "Sesiunea Google a expirat sau nu mai este validă. Reîncearcă autentificarea din această pagină.",
    googleCancelled: "Autentificarea Google a fost anulată. Poți încerca din nou.",
    googleCallbackFailed: "Autentificarea Google nu a putut fi finalizată. Reîncearcă; dacă problema persistă, contactează suportul.",
    noAccount: "Nu ai cont?",
    alreadyHaveAccount: "Ai deja cont?",
    registerLink: "Înregistrează-te",
    loginLink: "Autentifică-te",
    termsAgreePart1: "Sunt de acord cu prelucrarea datelor cu caracter personal conform ",
    termsAgreePrivacy: "Politicii de Confidențialitate",
    termsAgreePart2: " și accept ",
    termsAgreeTerms: "Termenii și Condițiile",
    termsAgreePart3: " site-ului.",
    recaptchaNoticePart1: "Acest site este protejat de reCAPTCHA și se aplică ",
    recaptchaNoticePrivacy: "Politica de Confidențialitate",
    recaptchaNoticePart2: " și ",
    recaptchaNoticeTerms: "Termenii de Serviciu",
    recaptchaNoticePart3: " Google.",
    validationReqName: "Te rugăm să introduci numele complet.",
    validationReqEmail: "Te rugăm să introduci adresa de email.",
    validationInvalidEmail: "Adresa de email nu este validă.",
    validationReqPassword: "Te rugăm să introduci o parolă.",
    validationMinPassword: "Parola trebuie să aibă minim 8 caractere.",
    validationReqConfirm: "Te rugăm să confirmi parola.",
    validationMismatch: "Parolele nu coincid.",
    validationReqTerms: "Te rugăm să accepți Termenii și Condițiile.",
    validationReqRobot: "Te rugăm să validezi că nu ești robot.",
    validationLoginFailed: "Autentificare eșuată",
    validationRegisterFailed: "Înregistrare eșuată",
    validationTokenMissing: "Token invalid sau lipsă.",
    validationResetFailed: "Resetarea parolei a eșuat.",
    rateLimitCountdown: "Prea multe încercări. Te rugăm să aștepți {seconds} secunde înainte de a reîncerca.",
    serviceUnavailable: "Serviciul de autentificare este temporar indisponibil. Încearcă din nou în câteva momente.",
    recaptchaUnavailable: "Serviciul de securitate este momentan indisponibil. Te rugăm să reîncerci peste câteva momente.",
    decoCases: "Spețe",
    decoAccuracy: "Acuratețe",
    decoRating: "Rating",
    decoTaglinePart1: "Platforma juridică inteligentă",
    decoTaglinePart2: "pentru profesioniști și justițiabili",
    explorePlatform: "Explorează Platforma",
    emailSentTitle: "Verifică-ți emailul",
    emailSentBody: "Ți-am trimis un link de confirmare la adresa {email}. Accesează linkul pentru a-ți activa contul.",
    emailSentSpamHint: "Nu ai primit emailul? Verifică și folderul Spam.",
    backToLoginBtn: "Înapoi la autentificare",
    forgotTitle: "Resetare Parolă",
    forgotSubtitle: "Introdu adresa de email pentru a primi instrucțiunile",
    forgotSuccessTitle: "Email Trimis",
    forgotSuccessBody: "Dacă există un cont asociat cu {email}, vei primi în curând un email cu instrucțiuni pentru resetarea parolei.",
    forgotBackToLogin: "Înapoi la Autentificare",
    forgotSendInstructions: "Trimite Instrucțiuni",
    forgotErrorRequest: "Solicitarea de resetare a parolei a eșuat.",
    resetTitle: "Resetare Parolă",
    resetSubtitle: "Introdu noua parolă pentru contul tău",
    resetNewPasswordLabel: "Noua Parolă",
    resetConfirmPasswordLabel: "Confirmă Parola",
    resetBtn: "Resetează Parola",
    verifyLoading: "Verificăm emailul...",
    verifySuccessTitle: "Succes!",
    verifySuccessBody: "Email verificat cu succes! Vei fi redirecționat...",
    verifyErrorTitle: "Eroare",
    verifyGoToSearch: "Mergi la pagina de căutare",
    completeWelcome: "Bun venit pe LegeaAplicata.ro!",
    completeThanks: "Îți mulțumim că te-ai alăturat comunității noastre. Contul tău a fost creat cu succes folosind adresa de email {email}.",
    completeAccessBtn: "Accesează Platforma",
    completeFooterTerms: "Prin continuarea navigării accepți Termenii și Condițiile platformei."
  },
  en: {
    loginSeoTitle: "Login - LegeaAplicata.ro",
    loginSeoDesc: "Log in to your LegeaAplicata.ro account or create a new one. Access the AI legal assistant, case searches, and updated legislation.",
    loginSeoKeywords: "login legea aplicata, sign in, register account, legal platform",
    registerSeoTitle: "Register - LegeaAplicata.ro",
    registerSeoDesc: "Register for free and get instant access to artificial legal intelligence, jurisprudence search, and useful tools.",
    registerSeoKeywords: "register legea aplicata, new account, create account",
    verifyEmailSeoTitle: "Confirm Email - LegeaAplicata.ro",
    forgotPasswordSeoTitle: "Reset Password - LegeaAplicata.ro",
    resetPasswordSeoTitle: "Set New Password - LegeaAplicata.ro",
    completeProfileSeoTitle: "Welcome - LegeaAplicata.ro",
    welcomeTitle: "Welcome Back",
    createAccountTitle: "Create Account",
    loginSubtitle: "Sign in to your account to continue",
    registerSubtitle: "Register for free in seconds",
    loginTab: "Login",
    registerTab: "Create free account",
    emailLabel: "Email",
    emailPlaceholder: "example@email.com",
    passwordLabel: "Password",
    passwordPlaceholder: "••••••••",
    confirmPasswordLabel: "Confirm Password",
    confirmPasswordPlaceholder: "Repeat password",
    fullNameLabel: "Full Name",
    fullNamePlaceholder: "First and Last Name",
    passwordMinChars: "At least 8 characters, including letters and numbers",
    passwordTooShort: "Password must contain at least 8 characters.",
    passwordLettersDigits: "Use at least one letter and one digit (0–9).",
    passwordWeak: "This password is too easy to guess. Choose another.",
    passwordTooLong: "Password is too long: maximum 72 UTF-8 bytes. Some characters use more than one byte.",
    passwordInvalidCharacter: "Password contains an unsupported character.",
    changePassword: "Change password",
    changePasswordHint: "For account security, we will email you a link to set a new password.",
    showPassword: "Show password",
    hidePassword: "Hide password",
    adminPasswordHint: "Set a new password. The password is not sent by email.",
    passwordUpdated: "Password reset successfully!",
    cancelPassword: "Cancel",
    rememberMe: "Remember me",
    forgotPasswordLink: "Forgot password?",
    orDivider: "Or continue with",
    loginWithGoogle: "Sign in with Google",
    registerWithGoogle: "Create account with Google",
    googleRateLimited: "Too many attempts with Google. Please wait before trying again.",
    googleRetryCountdown: "Try again in {seconds} seconds",
    googleRegistrationHint: "No new password. Review the terms in the next step.",
    registerWithEmailDivider: "Or create an account with email",
    googleRegistrationSubtitle: "One step before continuing to Google.",
    googleRegistrationNext: "Choose your Google account, then return automatically to the platform. Your name and email come from the account you select.",
    googleConsentBefore: "By selecting “Accept and continue with Google”, you accept the ",
    googleConsentBetween: " and confirm that you have read the ",
    googleConsentPrivacy: "Privacy Policy",
    googleAcceptContinue: "Accept and continue with Google",
    googleRedirecting: "Opening Google…",
    backToRegistrationMethods: "Back to sign-up methods",
    accountType: "Account type",
    accountTypeIndividual: "Individual",
    accountTypeCompany: "Company",
    accountTypeHint: "Billing details are entered separately before payment and may differ from the account type.",
    googleAccountNotFound: "This Google account is not registered yet. To create your account, review the terms below and continue with Google.",
    googleEmailConflict: "This Google address is already linked to an account created with email and password. Sign in with your password or reset it.",
    googleInvalidState: "The Google session expired or is no longer valid. Start the sign-in process again from this page.",
    googleCancelled: "Google sign-in was cancelled. You can try again.",
    googleCallbackFailed: "Google sign-in could not be completed. Try again; if the problem persists, contact support.",
    noAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?",
    registerLink: "Register",
    loginLink: "Log in",
    termsAgreePart1: "I agree to the processing of personal data according to the ",
    termsAgreePrivacy: "Privacy Policy",
    termsAgreePart2: " and accept the ",
    termsAgreeTerms: "Terms and Conditions",
    termsAgreePart3: " of the site.",
    recaptchaNoticePart1: "This site is protected by reCAPTCHA and the Google ",
    recaptchaNoticePrivacy: "Privacy Policy",
    recaptchaNoticePart2: " and ",
    recaptchaNoticeTerms: "Terms of Service",
    recaptchaNoticePart3: " apply.",
    validationReqName: "Please enter your full name.",
    validationReqEmail: "Please enter your email address.",
    validationInvalidEmail: "Email address is not valid.",
    validationReqPassword: "Please enter a password.",
    validationMinPassword: "Password must be at least 8 characters.",
    validationReqConfirm: "Please confirm your password.",
    validationMismatch: "Passwords do not match.",
    validationReqTerms: "Please accept the Terms and Conditions.",
    validationReqRobot: "Please validate that you are not a robot.",
    validationLoginFailed: "Authentication failed",
    validationRegisterFailed: "Registration failed",
    validationTokenMissing: "Invalid or missing token.",
    validationResetFailed: "Failed to reset password.",
    rateLimitCountdown: "Too many attempts. Please wait {seconds} seconds before trying again.",
    serviceUnavailable: "Authentication service is temporarily unavailable. Please try again in a moment.",
    recaptchaUnavailable: "Security verification service is temporarily unavailable. Please try again in a moment.",
    decoCases: "Cases",
    decoAccuracy: "Accuracy",
    decoRating: "Rating",
    decoTaglinePart1: "The intelligent legal platform",
    decoTaglinePart2: "for professionals and litigants",
    explorePlatform: "Explore the Platform",
    emailSentTitle: "Verify your email",
    emailSentBody: "We sent a confirmation link to {email}. Click the link to activate your account.",
    emailSentSpamHint: "Didn't receive the email? Check the Spam folder as well.",
    backToLoginBtn: "Back to login",
    forgotTitle: "Reset Password",
    forgotSubtitle: "Enter your email address to receive instructions",
    forgotSuccessTitle: "Email Sent",
    forgotSuccessBody: "If an account is associated with {email}, you will soon receive an email with instructions to reset your password.",
    forgotBackToLogin: "Back to Login",
    forgotSendInstructions: "Send Instructions",
    forgotErrorRequest: "Failed to request password reset.",
    resetTitle: "Reset Password",
    resetSubtitle: "Enter the new password for your account",
    resetNewPasswordLabel: "New Password",
    resetConfirmPasswordLabel: "Confirm Password",
    resetBtn: "Reset Password",
    verifyLoading: "Verifying email...",
    verifySuccessTitle: "Success!",
    verifySuccessBody: "Email successfully verified! Redirecting...",
    verifyErrorTitle: "Error",
    verifyGoToSearch: "Go to search page",
    completeWelcome: "Welcome to LegeaAplicata.ro!",
    completeThanks: "Thank you for joining our community. Your account has been successfully created using the email address {email}.",
    completeAccessBtn: "Access the Platform",
    completeFooterTerms: "By continuing to browse you accept the Terms and Conditions of the platform."
  },
  fr: {
    loginSeoTitle: "Connexion - LegeaAplicata.ro",
    loginSeoDesc: "Connectez-vous à votre compte LegeaAplicata.ro ou créez-en un nouveau. Accès à l'assistant juridique IA, recherche de jurisprudence et législation mise à jour.",
    loginSeoKeywords: "connexion legea aplicata, s'identifier, creer un compte, plateforme juridique",
    registerSeoTitle: "Inscription - LegeaAplicata.ro",
    registerSeoDesc: "Inscrivez-vous gratuitement et bénéficiez d'un accès instantané à l'intelligence artificielle juridique, à la recherche de jurisprudence et à des outils utiles.",
    registerSeoKeywords: "inscription legea aplicata, nouveau compte, creer un compte",
    verifyEmailSeoTitle: "Confirmer l'E-mail - LegeaAplicata.ro",
    forgotPasswordSeoTitle: "Réinitialiser le Mot de Passe - LegeaAplicata.ro",
    resetPasswordSeoTitle: "Définir un Nouveau Mot de Passe - LegeaAplicata.ro",
    completeProfileSeoTitle: "Bienvenue - LegeaAplicata.ro",
    welcomeTitle: "Bon Retour",
    createAccountTitle: "Créer un Compte",
    loginSubtitle: "Connectez-vous à votre compte pour continuer",
    registerSubtitle: "Inscrivez-vous gratuitement en quelques secondes",
    loginTab: "Connexion",
    registerTab: "Créer un compte gratuit",
    emailLabel: "E-mail",
    emailPlaceholder: "exemple@email.com",
    passwordLabel: "Mot de passe",
    passwordPlaceholder: "••••••••",
    confirmPasswordLabel: "Confirmer le mot de passe",
    confirmPasswordPlaceholder: "Répétez le mot de passe",
    fullNameLabel: "Nom complet",
    fullNamePlaceholder: "Nom et Prénom",
    passwordMinChars: "Au moins 8 caractères, avec des lettres et des chiffres",
    passwordTooShort: "Le mot de passe doit contenir au moins 8 caractères.",
    passwordLettersDigits: "Utilisez au moins une lettre et un chiffre (0–9).",
    passwordWeak: "Ce mot de passe est trop facile à deviner. Choisissez-en un autre.",
    passwordTooLong: "Mot de passe trop long : maximum 72 octets UTF-8. Certains caractères utilisent plusieurs octets.",
    passwordInvalidCharacter: "Le mot de passe contient un caractère non accepté.",
    changePassword: "Changer le mot de passe",
    changePasswordHint: "Pour sécuriser votre compte, nous vous enverrons un lien par e-mail pour définir un nouveau mot de passe.",
    showPassword: "Afficher le mot de passe",
    hidePassword: "Masquer le mot de passe",
    adminPasswordHint: "Définissez un nouveau mot de passe. Il ne sera pas envoyé par e-mail.",
    passwordUpdated: "Mot de passe réinitialisé !",
    cancelPassword: "Annuler",
    rememberMe: "Se souvenir de moi",
    forgotPasswordLink: "Mot de passe oublié ?",
    orDivider: "Ou continuer avec",
    loginWithGoogle: "Se connecter avec Google",
    registerWithGoogle: "Créer un compte avec Google",
    googleRateLimited: "Trop de tentatives avec Google. Veuillez patienter avant de réessayer.",
    googleRetryCountdown: "Réessayez dans {seconds} secondes",
    googleRegistrationHint: "Sans nouveau mot de passe. Consultez les conditions à l’étape suivante.",
    registerWithEmailDivider: "Ou créez un compte par email",
    googleRegistrationSubtitle: "Une étape avant de continuer avec Google.",
    googleRegistrationNext: "Choisissez votre compte Google, puis revenez automatiquement sur la plateforme. Votre nom et votre adresse email proviennent du compte choisi.",
    googleConsentBefore: "En sélectionnant « Accepter et continuer avec Google », vous acceptez les ",
    googleConsentBetween: " et confirmez avoir lu la ",
    googleConsentPrivacy: "Politique de confidentialité",
    googleAcceptContinue: "Accepter et continuer avec Google",
    googleRedirecting: "Ouverture de Google…",
    backToRegistrationMethods: "Retour aux méthodes d’inscription",
    accountType: "Type de compte",
    accountTypeIndividual: "Particulier",
    accountTypeCompany: "Entreprise",
    accountTypeHint: "Les informations de facturation sont saisies séparément avant le paiement et peuvent différer du type de compte.",
    googleAccountNotFound: "Ce compte Google n’est pas encore inscrit. Pour créer votre compte, consultez les conditions ci-dessous et continuez avec Google.",
    googleEmailConflict: "Cette adresse Google est déjà associée à un compte créé avec une adresse e-mail et un mot de passe. Connectez-vous avec votre mot de passe ou réinitialisez-le.",
    googleInvalidState: "La session Google a expiré ou n'est plus valide. Relancez la connexion depuis cette page.",
    googleCancelled: "La connexion Google a été annulée. Vous pouvez réessayer.",
    googleCallbackFailed: "La connexion Google n'a pas pu être finalisée. Réessayez ; si le problème persiste, contactez le support.",
    noAccount: "Vous n'avez pas de compte ?",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    registerLink: "S'inscrire",
    loginLink: "Se connecter",
    termsAgreePart1: "J'accepte le traitement des données personnelles conformément à la ",
    termsAgreePrivacy: "Politique de Confidentialité",
    termsAgreePart2: " et j'accepte les ",
    termsAgreeTerms: "Conditions Générales",
    termsAgreePart3: " du site.",
    recaptchaNoticePart1: "Ce site est protégé par reCAPTCHA et la ",
    recaptchaNoticePrivacy: "Politique de Confidentialité",
    recaptchaNoticePart2: " et les ",
    recaptchaNoticeTerms: "Conditions d'Utilisation",
    recaptchaNoticePart3: " de Google s'appliquent.",
    validationReqName: "Veuillez saisir votre nom complet.",
    validationReqEmail: "Veuillez saisir votre adresse e-mail.",
    validationInvalidEmail: "L'adresse e-mail n'est pas valide.",
    validationReqPassword: "Veuillez saisir un mot de passe.",
    validationMinPassword: "Le mot de passe doit comporter au moins 8 caractères.",
    validationReqConfirm: "Veuillez confirmer votre mot de passe.",
    validationMismatch: "Les mots de passe ne correspondent pas.",
    validationReqTerms: "Veuillez accepter les Conditions Générales.",
    validationReqRobot: "Veuillez valider que vous n'êtes pas un robot.",
    validationLoginFailed: "Échec de l'authentification",
    validationRegisterFailed: "Échec de l'inscription",
    validationTokenMissing: "Jeton invalide ou manquant.",
    validationResetFailed: "Échec de la réinitialisation du mot de passe.",
    rateLimitCountdown: "Trop de tentatives. Veuillez patienter {seconds} secondes avant de réessayer.",
    serviceUnavailable: "Le service d'authentification est temporairement indisponible. Veuillez réessayer dans quelques instants.",
    recaptchaUnavailable: "Le service de sécurité est temporairement indisponible. Veuillez réessayer dans quelques instants.",
    decoCases: "Dossiers",
    decoAccuracy: "Précision",
    decoRating: "Évaluation",
    decoTaglinePart1: "La plateforme juridique intelligente",
    decoTaglinePart2: "pour les professionnels et les associés",
    explorePlatform: "Explorer la Plateforme",
    emailSentTitle: "Vérifiez votre e-mail",
    emailSentBody: "Nous avons envoyé un lien de confirmation à {email}. Cliquez sur le lien pour activer votre compte.",
    emailSentSpamHint: "Vous n'avez pas reçu l'e-mail ? Vérifiez également le dossier Spam.",
    backToLoginBtn: "Retour à la connexion",
    forgotTitle: "Réinitialisation",
    forgotSubtitle: "Saisissez votre adresse e-mail pour recevoir les instructions",
    forgotSuccessTitle: "E-mail Envoyé",
    forgotSuccessBody: "Si un compte est associé à {email}, vous recevrez bientôt un e-mail contenant des instructions pour réinitialiser votre mot de passe.",
    forgotBackToLogin: "Retour à la Connexion",
    forgotSendInstructions: "Envoyer les Instructions",
    forgotErrorRequest: "Échec de la demande de réinitialisation du mot de passe.",
    resetTitle: "Réinitialisation",
    resetSubtitle: "Saisissez le nouveau mot de passe pour votre compte",
    resetNewPasswordLabel: "Nouveau Mot de passe",
    resetConfirmPasswordLabel: "Confirmer le Mot de passe",
    resetBtn: "Réinitialiser le Mot de passe",
    verifyLoading: "Vérification de l'e-mail...",
    verifySuccessTitle: "Succès !",
    verifySuccessBody: "E-mail vérifié avec succès ! Redirection...",
    verifyErrorTitle: "Erreur",
    verifyGoToSearch: "Aller à la page de recherche",
    completeWelcome: "Bienvenue sur LegeaAplicata.ro !",
    completeThanks: "Merci d'avoir rejoint notre communauté. Votre compte a été créé avec succès avec l'adresse e-mail {email}.",
    completeAccessBtn: "Accéder à la Plateforme",
    completeFooterTerms: "En continuant à naviguer, vous acceptez les Conditions Générales de la plateforme."
  }
};

export default authTranslations;
